import { Card } from "@mantine/core"
import { Entity } from "@/lib/schemas"
import { cn } from "@/lib/utils"
import { Link } from "react-router"

export interface GridItemProps<T> {
  item: T
  routePath?: string
  loading?: boolean
  className?: string
  cardClassName?: string
  animated?: boolean
  animationDelay?: number
  replace?: boolean
  onClick?: () => void
}

function GridItem<T extends Entity>(props: GridItemProps<T> & { children: React.ReactNode; to: string }) {
  return (
    <Link
      to={props.to}
      className={cn(
        `rounded-2xl border border-solid border-border outline-primary hover:outline-2`,
        props.loading && "animate-duration-1000 animate-pulse",
        props.className,
        props.animated && "animate-fade-up animate-duration-200",
      )}
      style={
        props.animationDelay
          ? {
              animationDelay: `${props.animationDelay}ms`,
            }
          : undefined
      }
      onClick={props.onClick}
    >
      <Card padding="lg" radius="lg" className={cn(`relative size-full`, props.cardClassName)}>
        {props.children}
      </Card>
    </Link>
  )
}

export default GridItem
